
<template>
  <div>
    <wrapper-edit
      :wrapper-width="wrapperWidth"
      @back="paasPageBack">
      <Form ref="paasForm" slot="form"
            :model="paasFormData"
            :rules="paasFormRules"
            :label-width="defaultLabelWidth">
        <Row>
          <FormItem label="数据组名称：" prop="name" class="ivu-col-span-24" >
            <Input v-model="paasFormData.name"
                   clearable ></Input>
          </FormItem>
        </Row>
        <Row>
          <FormItem label="数据提示：" prop="info" class="ivu-col-span-24" >
            <Input v-model="paasFormData.info"
                   clearable ></Input>
          </FormItem>
        </Row>
        <Row>
          <FormItem label="数据字段：" prop="configName" class="ivu-col-span-24" >
            <Input v-model="paasFormData.configName"
                   clearable ></Input>
          </FormItem>
        </Row>
        <FormItem v-for="(item, index) in typelist" :label="'字段' + (index+1)" :key="index">
          <row type="flex" ref="typelist" align="middle">
            <Col span="10">
              <row>
                <Col span="23">
                  <FormItem>
                    <Input :placeholder="item.name.placeholder" v-model="item.name.value"></Input>
                  </FormItem>
                </Col>
              </row>
              <row>
                <Col span="23">
                  <FormItem>
                    <Input :placeholder="item.title.placeholder" v-model="item.title.value"></Input>
                  </FormItem>
                </Col>
              </row>
              <row>
                <Col span="23">
                  <FormItem>
                    <Select :placeholder="item.type.placeholder" v-model="item.type.value">
                      <Option value="input">文本框</Option>
                      <Option value="textarea">多行文本框</Option>
                      <Option value="color">颜色选择器</Option>
                      <Option value="radio">单选框</Option>
                      <Option value="checkbox">多选框</Option>
                      <Option value="select">下拉选择</Option>
                      <Option value="upload">单图</Option>
                      <Option value="uploads">多图</Option>
                      <Option value="entity">下拉实体类</Option>
                      <Option value="video">视频</Option>
                    </Select>
                  </FormItem>
                </Col>
              </row>
            </Col>
            <Col span="12">
              <FormItem>
                <Input type="textarea" rows="4" :placeholder="item.param.placeholder" v-model="item.param.value"></Input>
              </FormItem>
            </Col>
            <Col span="2" style="display:inline-block; text-align:right;">
              <Button type="primary"  @click="removeType(index)">
                <Icon type="ios-close" size="24"></Icon>
              </Button>
            </Col>
          </row>
        </FormItem>
        <FormItem><Button type="primary" @click="addType">添加字段</Button></FormItem>

        <div class="edit-oper-toolbar">
          <Button type="primary" @click="paasFormSubmit('paasForm','','add')">保存并继续添加</Button>
          <Button @click="paasFormSubmit('paasForm','','systemGroupList')" style="margin-left: 8px">保存并返回</Button>
          <Button @click="paasPageBack" style="margin-left: 8px">返回</Button>
        </div>
      </Form>
    </wrapper-edit>
  </div>
</template>
<script>
  import wrapperEdit from "@/components/paas/wrapper-edit";
  import metaEdit from "@/assets/js/meta-edit.js";

  export default {
    name: "edit",
    mixins:[metaEdit],
    components:{wrapperEdit},
    data(){
      return {
        serviceUrl:"/eb/system/group",  //每个页面访问后台服务器的路径
        currentIdFiledName: 'id',
        paasFormData:{
          id:'',
          name:'',
          fields:'',
          info:'',
          configName:'',
          isDelete:"0"
        },
        typelist:[],
        paasFormRules:{
        },
        redirectName:"systemGroupList",
        nextAddName:"systemGroupEdit",
      }
    },
    methods:{
      create(){
        let queryParam = this.$route.query;
      let param = '';
      for(let key in queryParam) {
        if(key === "queryParam") {
          continue;
        }
        if(param) {
          param += "&";
        }
        param += key+"="+this.$route.query[key];
      }
        this.axios.post(this.$store.state.sysApi+this.serviceUrl+"/edit?"+param).then(res => {
          if(res.code === 200) {
            let data = res.data;
            let entity = data.entity;
            this.paasFormData.id = entity.id;
            this.paasFormData.name = entity.name;
            this.paasFormData.fields = entity.fields;
            this.paasFormData.info = entity.info;
            this.paasFormData.configName = entity.configName;
            this.paasFormData.isDelete =  entity.isDelete;
            this.typelist = entity.typelist;
            this.paasFormData.paasRepeatSubmitFlag = data.paasRepeatSubmitFlag;
          }
        }).catch(function(error){
          this.$Message.error('数据加载失败，请重试！');
        });
      },
      removeType: function(index){
        this.typelist.splice(index,1);
      },
      addType: function(){
        this.typelist.push({
          name: {
            placeholder: "字段名称：姓名",
            value: ''
          },
          title: {
            placeholder: "字段配置名：name",
            value: ''
          },
          type: {
            placeholder: "字段类型",
            value: ''
          },
          param: {
            placeholder: "参数方式例如:\n1=白色\n2=红色\n3=黑色",
            value: ''
          }
        })
      },
      /**
       * 提交前逻辑
       */
      paasFormSaveBefore(){
        //组装Fields数据
        let filedArr = [];
        if(this.typelist != null && this.typelist.length > 0){
          for(let item of this.typelist){
            let fieldObj = {};
            fieldObj.name = item.name.value;
            fieldObj.title = item.title.value;
            fieldObj.type = item.type.value;
            fieldObj.param = item.param.value;
            filedArr.push(fieldObj);
          }
        }
        this.paasFormData.fields = JSON.stringify(filedArr);
      },
    }
  }
</script>
